import { AppStore } from "./Store/AppStore";
import socketio from "socket.io-client";
import config from "../config";
import { STORE_AUTH } from "./Store/AuthStore";
import { createRoutes, ROUTE_LOGIN } from "./routes";
import createRouter from "router5";
import browserPlugin from "router5/plugins/browser";
import persistentParamsPlugin from "router5/plugins/persistentParams";
import ReactDOM from "react-dom";
import App from "./Containers/App/App";
import React from "react";
import { CookiesProvider } from "react-cookie";
import { login } from "./utility";
import { Loader, LoaderGlobal } from "./Components/Loader/Loader";
import { object } from "prop-types";

const ERR_INVALID_TOKEN = "INVALID_TOKEN";

const networkTimeout = {};

let appStore;
let router;
let socket;

function initApp(rawState) {
  appStore = new AppStore(rawState);
  socket = socketio(config.WEBSOCKET_URL(window));
  //const SOCKETIO_PORT = window.location.hostname === 'localhost' ? 33330 : 8092
  //const SOCKETIO_URL = window.location.hostname === 'localhost' ? 'http://46.107.199.32' : window.location.protocol + '//' + window.location.hostname
  //const socket = socketio(SOCKETIO_URL + ':' + SOCKETIO_PORT);

  const mware = (router) => (toState, fromState, done) => {
    done(
      !appStore.get(STORE_AUTH).token && toState.name !== ROUTE_LOGIN
        ? { redirect: { name: ROUTE_LOGIN } }
        : undefined
    );
  };

  socket.emitWithToken = function (eventName, data = {}, cb) {
    LoaderGlobal.show();

    const random = Math.random();
    networkTimeout[random] = setTimeout(
      () => handleNetworkTimeout(random),
      30000
    );
    const newCb = function (err, data) {
      clearTimeout(networkTimeout[random]);
      delete networkTimeout[random];
      if (Object.entries(networkTimeout).length === 0) LoaderGlobal.hide();

      if (err && err.Message && err.Message === ERR_INVALID_TOKEN) {
        const authStore = appStore.get(STORE_AUTH);
        login(socket, authStore, () => {
          if (authStore.token) {
            socket.emitWithToken(eventName, data, cb);
          }
        });
      } else {
        cb(err, data);
      }
    };

    data.Token = appStore.get(STORE_AUTH).token;

    if (!data.Token) {
      //setCookie('name', newName, { path: '/' });
    }

    return socket.emit(eventName, data, newCb);
  };

  router = createRouter(createRoutes(socket), {
    allowNotFound: true,
  })
    .usePlugin(browserPlugin())
    .usePlugin(persistentParamsPlugin())
    .useMiddleware(mware);

  router.start(() => {
    ReactDOM.render(
      <CookiesProvider>
        <Loader />
        <App appStore={appStore} router={router} socket={socket} />
      </CookiesProvider>,
      window.document.getElementById("app")
    );
  });

  return {
    store: appStore,
  };
}

function handleNetworkTimeout(random) {
  console.log("TIMEOUT");
  delete networkTimeout[random];
  if (Object.entries(networkTimeout).length === 0) LoaderGlobal.hide();

  ReactDOM.render(
    <CookiesProvider>
      <Loader />
      <App
        appStore={appStore}
        router={router}
        socket={socket}
        networkpopup={true}
      />
    </CookiesProvider>,
    window.document.getElementById("app")
  );
}

export default initApp;
